import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

// Two-factor (authenticator app) in front of the admin area: set up once with a QR code, then a 6-digit code each session.
export default function AdminMfa({ children }) {
  const [state, setState] = useState('checking')   // checking | enroll | challenge | ok | error
  const [factorId, setFactorId] = useState(null)
  const [qr, setQr] = useState('')
  const [secret, setSecret] = useState('')
  const [code, setCode] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    let live = true
    ;(async () => {
      try {
        const { data: aal } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel()
        if (aal && aal.currentLevel === 'aal2') { if (live) setState('ok'); return }
        const { data: f } = await supabase.auth.mfa.listFactors()
        const verified = ((f && f.totp) || []).find(x => x.status === 'verified')
        if (verified) { if (live) { setFactorId(verified.id); setState('challenge') } return }
        for (const x of ((f && f.all) || []).filter(x => x.status !== 'verified')) { try { await supabase.auth.mfa.unenroll({ factorId: x.id }) } catch (e) {} }
        const { data, error } = await supabase.auth.mfa.enroll({ factorType: 'totp', friendlyName: 'Hey Captain admin ' + new Date().toISOString().slice(0, 10) })
        if (error) throw error
        if (live) { setFactorId(data.id); setQr(data.totp.qr_code); setSecret(data.totp.secret); setState('enroll') }
      } catch (e) { if (live) { setErr(e.message || String(e)); setState('error') } }
    })()
    return () => { live = false }
  }, [])

  async function verify() {
    setErr(''); setBusy(true)
    const { error } = await supabase.auth.mfa.challengeAndVerify({ factorId, code: code.replace(/\s+/g, '') })
    setBusy(false)
    if (error) { setErr(error.message === 'Invalid TOTP code entered' ? 'Wrong code - check the time on your phone and try the current code' : error.message); return }
    setState('ok')
  }

  if (state === 'ok') return children
  const box = { maxWidth: 420, margin: '60px auto', padding: 28, borderRadius: 14, background: 'var(--hull)', border: '0.5px solid var(--border)', textAlign: 'center', color: 'var(--text)' }
  const inp = { width: 180, padding: '10px 12px', fontSize: 22, letterSpacing: '.3em', textAlign: 'center', borderRadius: 10, border: '1px solid var(--border)', background: 'var(--ink)', color: 'var(--text)' }
  return (
    <div style={box}>
      <div style={{ color: '#76601f', fontWeight: 800, letterSpacing: '.18em', fontSize: 11 }}>HEY CAPTAIN ADMIN</div>
      {state === 'checking' && <p style={{ color: 'var(--muted)' }}>Checking two-factor&hellip;</p>}
      {state === 'error' && <><p style={{ color: '#C93B47' }}>Two-factor problem: {err}</p><button className="btn" onClick={() => window.location.reload()}>Try again</button></>}
      {state === 'enroll' && (
        <>
          <h3 style={{ margin: '10px 0 6px' }}>Set up two-factor</h3>
          <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.5 }}>Scan this code with an authenticator app (Google Authenticator, Microsoft Authenticator, 1Password&hellip;), then type the 6-digit code it shows.</p>
          {qr && <img src={qr} alt="QR code" style={{ width: 200, height: 200, background: '#fff', padding: 8, borderRadius: 10, margin: '8px auto', display: 'block' }} />}
          <div style={{ fontSize: 11.5, color: 'var(--muted)', wordBreak: 'break-all', marginBottom: 12 }}>Can't scan? Enter this key: <b>{secret}</b></div>
        </>
      )}
      {state === 'challenge' && (
        <>
          <h3 style={{ margin: '10px 0 6px' }}>Two-factor code</h3>
          <p style={{ fontSize: 13, color: 'var(--muted)' }}>Enter the 6-digit code from your authenticator app.</p>
        </>
      )}
      {(state === 'enroll' || state === 'challenge') && (
        <>
          <input style={inp} value={code} onChange={e => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" maxLength={7} placeholder="000000" autoFocus onKeyDown={e => { if (e.key === 'Enter') verify() }} />
          {err && <div style={{ color: '#C93B47', fontSize: 13, marginTop: 8 }}>{err}</div>}
          <div style={{ marginTop: 14 }}><button className="btn btn-primary" disabled={busy || code.replace(/\s+/g, '').length !== 6} onClick={verify}>{busy ? 'Checking\u2026' : 'Verify'}</button></div>
        </>
      )}
    </div>
  )
}
